import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=22dc384e&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"
import style0 from "./userList.vue?vue&type=style&index=0&id=22dc384e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc384e",
  null
  
)

export default component.exports